<div
  class="tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-between tw-border tw-border-geyser tw-bg-white tw-py-5 tw-pl-5 tw-pr-15 hb-group:tw-border-x-0 hb-group:tw-border-b hb-group:tw-border-t-0 hb-group:tw-border-porcelain hb-group:tw-px-0"
  [attr.data-test-id]="id() + '_wrapper'"
>
  <button
    type="button"
    [attr.aria-expanded]="_expanded()"
    [attr.aria-controls]="id()"
    (click)="toggleExpanded($event)"
    class="tw-flex tw-w-full tw-items-center tw-justify-between"
    [attr.data-test-id]="id() + '_btn'"
  >
    <p
      class="tw-flex tw-items-center tw-gap-4 tw-text-left tw-text-base tw-font-semibold mb-group:tw-font-sans hb-group:tw-text-hb-base hb-group:tw-font-medium hb-group:tw-text-midnight-green"
    >
      @if (iconName() && showIcon()) {
        <ia-icons class="tw-size-12" [name]="iconName()" />
      }
      {{ title() }}
    </p>

    <ia-icon
      name="chevron_down_rounded"
      class="tw-size-6 tw-transition-transform tw-duration-300 tw-ease-out hb-group:tw-size-5 hb-group:tw-text-midnight-green"
      [class]="{ 'tw-rotate-180': _expanded() }"
    />
  </button>

  <button
    class="tw-w-full tw-cursor-default tw-overflow-hidden tw-text-left tw-transition-[max-height] tw-duration-300 tw-ease-in-out hb-group:tw-text-hb-base hb-group:tw-font-medium hb-group:tw-text-midnight-green"
    [attr.data-test-id]="id() + '_btn_content'"
    [attr.aria-expanded]="_expanded()"
    [attr.aria-controls]="id() + '_content'"
    [class]="{
      'tw-max-h-0': !_expanded(),
      'tw-h-auto tw-mt-5': _expanded(),
    }"
    (click)="$event.stopPropagation()"
  >
    <ng-content />
  </button>
</div>
